package com.pincer.app.viewmodel

/*
What a control does when someone uses it. Each control node carries one, with any arguments it needs bound when
the tree is built (which question, which candidate). The value the person types, picks or ticks arrives
separately, through Application.perform(compoundKey, value).

Until October 2026 a control's key was the name of an Application method and renderers called app[key](param,
value). Nothing checked that the method existed or took those arguments, or that the control was on screen.
Now Application.perform finds the node in the tree the person was last shown, checks the value against the
control, and dispatches with an exhaustive `when`, so adding an action without handling it doesn't compile.
See docs/design_notes/abstract_client.md.

Toggles take the value they're set to rather than flipping, so repeating an action (a double click, an agent
retrying) is harmless.
*/
sealed interface Action {

    // Signing in and the account
    data object PrincipalTriggerCode                        : Action
    data object PrincipalConfirmCode                        : Action
    data object SetPersonalName                             : Action
    data object LogoutThisDevice                            : Action
    data object LogoutAllDevices                            : Action

    // Settings for this device
    data object SetLocale                                   : Action
    data object SetZone                                     : Action
    data object SetShowAdvancedOptions                      : Action
    data object SetServerUrl                                : Action
    data object SetWebSocketUrl                             : Action
    data object ResetDevice                                 : Action

    // Opening and closing a node that opens on request (Node.open), by its compound key
    data class  SetOpen(val compoundKey: String)            : Action

    // Moving between pincers
    data class  LoadPincer(val pid: String)                 : Action
    data object SetNewPincerName                            : Action
    data object CreateNewPincer                             : Action

    // Taking part
    data class  ConfirmCandidate(val candidateId: String)   : Action
    data object SetDraftChat                                : Action
    data object AddChat                                     : Action
    data class  SetAnswer(val questionId: String)           : Action

    // Settings for this pincer
    data object SetPincerName                               : Action
    data object SetPincerDescription                        : Action
    data object SetUseOpenRole                              : Action
    data object SetOpenRole                                 : Action
    data object SetPincerRules                              : Action
    data object MakeTemplate                                : Action
    data object SetRedRules                                 : Action
    data object SetGreenRules                               : Action
    data object SetStencil                                  : Action

    // Questions
    data class  SetQuestionCode(val questionId: String)     : Action
    data class  SetQuestionWording(val questionId: String)  : Action
    data class  SetQuestionFormat(val questionId: String)   : Action
    data class  SetQuestionHelpText(val questionId: String) : Action
    data class  SetQuestionOptions(val questionId: String)  : Action
    data class  SetQuestionRegex(val questionId: String)    : Action
    data class  SetQuestionRoles(val questionId: String)    : Action
    data object SetNewQuestionCode                          : Action
    data object SetNewQuestionWording                       : Action
    data object SetNewQuestionFormat                        : Action
    data object SetNewQuestionHelpText                      : Action
    data object SetNewQuestionOptions                       : Action
    data object SetNewQuestionRegex                         : Action
    data object SetNewQuestionRoles                         : Action
    data object AddQuestion                                 : Action

}
